export default function Industries() {
  const industries = [
    {
      name: 'Finance & Accounting',
      description: 'Precision automation for reporting, reconciliation, forecasting, and internal workflows — designed for compliance-driven environments.',
      image: 'https://breakthruai2.lovable.app/assets/industry-finance-BmTw5U14.jpg',
      tags: ['Reporting automation', 'Reconciliation', 'Forecasting'],
    },
    {
      name: 'Healthcare & Medical',
      description: 'Reduce administrative burden and operational inefficiencies while maintaining data integrity, security, and patient-centric workflows.',
      image: 'https://breakthruai2.lovable.app/assets/industry-healthcare-BNCrPV3s.jpg',
      tags: ['Patient intake', 'Scheduling', 'HIPAA workflows'],
    },
    {
      name: 'Legal Services',
      description: 'Structured intelligence for intake, document handling, internal operations, and process optimization — without compromising confidentiality.',
      image: 'https://breakthruai2.lovable.app/assets/industry-legal-CTVB-ooL.jpg',
      tags: ['Document handling', 'Client intake', 'Case tracking'],
    },
    {
      name: 'Real Estate',
      description: 'Smarter deal pipelines, lead intelligence, and operational automation that help teams move faster with confidence.',
      image: 'https://breakthruai2.lovable.app/assets/industry-realestate-BvAyYaC5.jpg',
      tags: ['Deal pipelines', 'Lead intelligence', 'Transaction coordination'],
    },
    {
      name: 'Small Business & Government',
      description: 'Streamlined operations, citizen services, and process automation designed for lean teams and public-sector compliance requirements.',
      image: 'https://breakthruai2.lovable.app/assets/industry-realestate-BvAyYaC5.jpg',
      tags: ['Process automation', 'Citizen services', 'Compliance tracking'],
    },
  ];

  return (
    <section id="industries" className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-3 block">
            Industries
          </span>
          <h2 className="text-3xl lg:text-5xl font-display text-foreground mb-4 leading-tight">
            AI Automation for Every Service Industry
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Purpose-built automation solutions for regulated industries where operational efficiency and compliance drive success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="group bg-card rounded-xl border border-border hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 overflow-hidden"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>

              <div className="p-8">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    <i className="ri-building-line text-2xl text-primary"></i>
                  </div>
                </div>

                <h3 className="text-xl font-display font-semibold text-foreground mb-3">
                  {industry.name}
                </h3>

                <p className="text-muted-foreground text-sm leading-relaxed mb-5">
                  {industry.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {industry.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="text-xs font-medium px-3 py-1.5 rounded-full bg-primary/5 text-primary border border-primary/10"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}